import { selectors } from './constants';
import * as eventsModel from '../models/events';
import getFieldsByName from './getFieldsByName';
import getForm from './getForm';
import replaceInterpolationTags from '../text/replaceInterpolationTags';

/**
 * If `field` is actually a container div (not the input), select all inputs within the field
 */
const mapContainersToRealFields = (field) => (
  (field.tagName === 'DIV') ? Array.from(field.querySelectorAll(selectors.fields.join())) : field
);

/**
 * True if the field is a checkbox or radio input
 */
 const isCheckable = (field) => (
  field && ['checkbox', 'radio'].includes(field.type)
);

/**
 * If we have queried checkboxes, only get checked ones
 */
const filterCheckedInputs = (field) => (
  isCheckable(field) ? field.checked : true
);

/**
 * Maps a field to its value, dispatching an event to allow the input to
 * customize the value if need be
 */
const mapFieldValue = (field) => {
  const event = eventsModel.dispatchRetrieveFieldValueEvent(field, { value: field.value });
  return replaceInterpolationTags(getForm(field), event.detail.value);
};

/**
 * Gets the value of the field in an element (eg. form or panel) with the specified name attribute,
 * and dispatches an event to allow the field to modify the return value if necessary.
 *
 * @param {Element} parentElement - The form or panel that you wish to query fields on
 * @param {string|Element} field - The name of the field, or the element itself
 */
export default function getFieldValue(parentElement, field) {
  if (!field) { return; }

  let fields = typeof(field) === 'string' ? getFieldsByName(parentElement, field) : [field];
  fields = fields
    .flatMap(mapContainersToRealFields)
    .filter(filterCheckedInputs);

  const values = fields.map(mapFieldValue);
  return isCheckable(fields[fields.length - 1]) ? values.join() : values[values.length - 1];
}
